import { useSelector } from 'react-redux';
import { Modal } from 'antd';
import WarningIcon from '../../assets/image/svg/warning.svg';
import TextBase from '../../common/text';
import { Colors } from '../../themes/Colors';
import { convertPxToRem, translate } from '../../helper';
import ButtonGradient from '../../common/button-gradient';
import React from 'react';
import LocalStorage from '../../defined/localStorage';
import CloseIcon from '@mui/icons-material/Close';

const brand = JSON.parse(LocalStorage.getItem('branding'));

const LogoutModal = ({
                         visible,
                         width = "calc(var(--fs-hero)*8.25)",
                         handleCancel,
                         handleOk
                     }) => {
    const whiteLabel = useSelector((state) => state.User?.branding);
    return (
        <Modal visible={visible} footer={<div />} centered closeIcon={<CloseIcon sx={{fontSize:'calc(var(--fs-xl)*1.13)'}} onClick={handleCancel} />} style={{}} width={width}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: 'var(--sp-lg)'
                }}>
                <img
                    src={
                        WarningIcon
                    }
                    style={{ height: 'calc(var(--fs-xl)*5)', width: 'calc(var(--fs-xl)*5)' }}
                />
            </div>
            <TextBase
                style={{
                    color: Colors.black,
                    textAlign: 'center',
                    marginBottom: 'var(--sp-lg)'

                }}
                fontWeight={400}
                size={'var(--fs-body)'}
                color={Colors.titlePage}>
                {'logoutConfirmation'}
            </TextBase>
            <TextBase
                style={{
                    color: Colors.black,
                    textAlign: 'center',
                    marginBottom: 'var(--sp-lg)'

                }}
                fontWeight={700}
                size={'var(--fs-body)'}
                color={Colors.titlePage}>
                {'sureConfirmation'}
            </TextBase>
            <div style={{ display: 'flex' }}>
                <ButtonGradient
                    onClick={handleCancel}
                    textStyle={{
                        fontWeight: 700,
                        fontSize: 'var(--fs-body)',
                        lineHeight: 'var(--sp-lg)',
                        margin: 0,
                        color: Colors.grey
                    }}
                    title={translate('cancel')}
                    iconSize={24}
                    backgroundColor={Colors.white}
                    style={{
                        marginRight: 'var(--sp-md2)',
                        padding: '0px var(--sp-md2)',
                        border: `1px solid ${Colors.grey}`,
                        color: Colors.grey,
                        textTransform: 'uppercase'
                    }}
                />
                <ButtonGradient
                    onClick={handleOk}
                    textStyle={{ fontWeight: 700, fontSize: 'var(--fs-body)', lineHeight: 'var(--sp-lg)', margin: 0 }}
                    iconStyle={{}}
                    title={translate('ok')}
                    iconSize={24}
                    backgroundColor={whiteLabel?.web_button_color || brand?.web_button_color || Colors.black}
                    style={{
                        marginLeft: 'var(--sp-md2)',
                        textTransform: 'uppercase'
                    }}
                />
            </div>
        </Modal>
    );
};

export default LogoutModal;